
const getCachedUrl = (cachedImagesData, imageUrl) => {
	return cachedImagesData.get(imageUrl);
}


export {getCachedUrl}